import React, { useState } from "react";
import styled from "styled-components";
import { Upload, Button, Form, Row, Col } from "antd";
import { UploadOutlined } from "@ant-design/icons";

const StyledMediaGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`
const StyledMediaButton = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
    justify-content: flex-start;
`

const MultiMediaUploader = ({ values, setFieldValue, eventData, shop }) => {
    const [mediaFiles, setMediaFiles] = useState(values.media || []); // Начальное состояние из объекта афиши

    const handleUpload = ({ file }) => {
        const reader = new FileReader();
        reader.onload = async (e) => {
            const result = e.target?.result; // Base64 или URL файла
            const type = file.type.startsWith("image/") ? "image" : "video";
        
            const newMedia = {
              id: Date.now(),
              url: result,
              type,
            };
        
            const updatedMediaFiles = [...mediaFiles, newMedia];
            setMediaFiles(updatedMediaFiles);
            setFieldValue("media", updatedMediaFiles);
        
            // 🔹 Отправка файла на сервер
            const formData = new FormData();
            formData.append("media", file); // Имя поля должно быть "media"
        
            try {
                const uri = `${process.env.REACT_APP_API_URL}/shops/${shop?.id}/loyalty/events/${eventData.id}/media/upload`
                const response = await fetch(uri, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `${localStorage.getItem("accessToken")}`,
                    },
                    body: formData,
                });
            
                const serverResponse = await response.json();
                console.log("Загружено!");
            } catch (error) {
                console.error("Ошибка загрузки:", error);
            }
          };
          reader.readAsDataURL(file);
    };

    const handleRemove = (id) => {
        const updatedMediaFiles = mediaFiles.filter((file) => file.id !== id);
        setMediaFiles(updatedMediaFiles); // Убираем из превьюшек
        setFieldValue("media", updatedMediaFiles); // Убираем из `media` объекта афиши
    };

    const handleUploadToServer = () => {

    }

    return (
        <Form.Item label="Загрузить медиа">
            <StyledMediaButton>
                <Upload
                    accept="image/*,video/*"
                    showUploadList={false} // Отключаем автоматический список
                    multiple // Включаем возможность выбора нескольких файлов
                    beforeUpload={(file) => {
                        handleUpload({ file });
                            // return true; // Останавливаем автоматическую загрузку
                        }}
                >
                    <Button icon={<UploadOutlined />}>Выбрать медиа</Button>
                </Upload>
            </StyledMediaButton>
            <StyledMediaButton>
                <Row gutter={[16, 16]} style={{ marginTop: "10px" }}>
                    {mediaFiles.map((file) => (
                    <Col key={file.id} span={8}>
                        {file.type === "image" ? (
                        <img
                            src={file.url}
                            alt="Превью изображения"
                            style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "cover",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            }}
                        />
                        ) : (
                        <video
                            src={file.url}
                            controls
                            style={{
                            width: "100px",
                            height: "100px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            }}
                        />
                        )}
                        {/* <Button
                            danger
                            size="small"
                            onClick={() => handleUploadToServer()}
                            style={{ marginTop: "5px" }}
                            >
                            загрузить
                        </Button> */}
                        <Button
                            danger
                            size="small"
                            onClick={() => handleRemove(file.id)}
                            style={{ marginTop: "5px" }}
                            >
                            Удалить
                        </Button>
                    </Col>
                    ))}
                </Row>

            </StyledMediaButton>
            
        </Form.Item>
    );
};

export default MultiMediaUploader;
